import { inject, Injectable } from '@angular/core';
import { DcuMtuCommunicationCountsResponse, DcuToMtuCommunicationTable } from './dcu-to-mtu-communication.types';
import { DcuToMtuCommunicationApiService } from './dcu-to-mtu-communication.api.service';
import { DevicesPayload } from '../../equipment/devices/components/devices.models';
import { map, catchError, of, Observable } from 'rxjs';
import { ReportGroupFilterApiService } from '../../../services/api/report-group-filter/report-group-filter-api.service';
import { ReportGroupFilterResponse } from '../../../services/api/report-group-filter/report-group-filter-api.types';

@Injectable({ providedIn: 'root' })
export class DcuToMtuCommunicationService {
  private readonly api = inject(DcuToMtuCommunicationApiService);
  private readonly reportGroupFilterApiService = inject(ReportGroupFilterApiService);
  private readonly tableState = { data: [], total: 0 };

  getTableData(payload: DevicesPayload): Observable<DcuToMtuCommunicationTable> {
    return this.api.getAll(payload).pipe(
      map(communications => {
        const { items, totalCount } = communications;
        const data = items.map(item => {
          return {
            ...item,
            dcu: item.dcuReceptionAnalyticsItems.map(({ dcuId, dcuDeviceUID }) => {
              return { dcuId, dcuDeviceUID };
            }),
            transmissionCount: item.dcuReceptionAnalyticsItems.map(({ transmissionCount }) =>
              transmissionCount == null ? '' : transmissionCount.toString()
            ),
            averageRSSI: item.dcuReceptionAnalyticsItems.map(({ averageRSSI }) =>
              averageRSSI == null ? '' : averageRSSI.toString()
            ),
            reliability: item.dcuReceptionAnalyticsItems.map(({ reliability }) =>
              reliability == null ? '' : reliability.toString()
            ),
            serviceLocationIdRows: item.serviceLocationId ? item.serviceLocationId.split('\n') : [],
            serviceLocationAddressRows: item.serviceLocationAddress ? item.serviceLocationAddress.split('\n') : []
          };
        });
        return { data, total: totalCount };
      }),
      catchError(() => of(this.tableState))
    );
  }

  getCoverageStatistics(payload: DevicesPayload): Observable<DcuMtuCommunicationCountsResponse> {
    return this.api.getStatistics(payload);
  }

  getReportGroup(applicable: string): Observable<ReportGroupFilterResponse[]> {
    return this.reportGroupFilterApiService.getReportGroup(applicable);
  }
}
